<div class="order-form-summary-container" *ngIf="(showGstExclusive$ | async) !== null && product$ | async as product">
  <h1>{{ product.name }}</h1>
  <div class="summary-details d-flex justify-content-between align-items-center">
    <div class="d-flex flex-column justify-content-md-between flex-md-row w-100">
      <span class="text-black mb-1 mb-md-0">{{
        'orderForm.quantitySelected' | cxTranslate : { count: orderFormTotalSelected }
      }}</span>
      <div class="order-form-total" [ngClass]="{ 'is-SOH': showGstInclusive$ | async }">
        <span class="mr-3 mr-lg-5 total-label"
          >{{ 'orderForm.total' | cxTranslate : { price: orderFormTotalPrice | mycurrency } }}
        </span>
        <span class="gst-label" *ngIf="(showGstExclusive$ | async) && !showSrp">{{
          'gst.exclusive' | cxTranslate
        }}</span>
        <span class="gst-label" *ngIf="(showGstInclusive$ | async) && showSrp">{{
          'gst.inclusive' | cxTranslate
        }}</span>
      </div>
    </div>

    <cx-add-to-cart
      [showQuantity]="false"
      [showOrderFormLink]="false"
      [product]="product"
      [isDisabled]="orderFormTotalSelected === 0"
      [orderFormDetails]="orderFormDetailsList"
      [pageType]="orderForm"
    ></cx-add-to-cart>
  </div>
</div>
